import EventEditPage from './components/EventEditPage'

export default EventEditPage
